function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityAccessibilityFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.327 19.766l5.544 6.743 1.629-1.34-6.175-7.512H14.74v-4.77h6.97v-2.11h-9.079v8.989h8.695z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88 5.504a3.81 3.81 0 003.806 3.807 3.81 3.81 0 003.807-3.807 3.81 3.81 0 00-3.806-3.806A3.81 3.81 0 009.88 5.504zm2.109 0a1.7 1.7 0 011.697-1.697 1.7 1.7 0 011.698 1.697 1.7 1.7 0 01-1.697 1.698 1.7 1.7 0 01-1.698-1.698z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.398 25.827a8.043 8.043 0 001.732-2.567l1.469 1.786a10.137 10.137 0 01-1.71 2.272 10.112 10.112 0 01-3.238 2.183c-1.255.532-2.589.801-3.965.801-1.375 0-2.709-.269-3.964-.801a10.142 10.142 0 01-3.24-2.182A10.16 10.16 0 013.5 20.116a10.153 10.153 0 012.983-7.203 10.147 10.147 0 013.239-2.183v2.351a8.053 8.053 0 00-4.113 7.035 8.056 8.056 0 002.365 5.711 8.09 8.09 0 002.57 1.733c1.989.84 4.297.84 6.286 0a8.074 8.074 0 002.569-1.733z",
    fill: props.color
  }));
}

export default SvgIconFacilityAccessibilityFilled;